<template>
  <blob-panel is-wide>
    <form @submit.prevent="submit">
      <h2 class="text-center">
        Two-factor authentication
      </h2>
      <p>The admin of the current account has made Two-Factor Authentication required.</p>
      <p>
        Set up your two factor authentication by scanning the barcode below. <br>Alternatively, you can use the code
        <b v-text="google2faSecret" />.
      </p>

      <img :src="qrImage" style="display: block;margin-left: auto; margin-right: auto">

      <ol>
        <li>Download and install a two-factor authentication app like <b>Google Authenticator</b> or <b>Authy</b></li>
        <li>Scan the QR code, or enter this code <b v-text="google2faSecret" /></li>
        <li>Enter the confirm code from your authentication app</li>
      </ol>

      <hr>

      <div class="form-group" :class="{'has-error': failure}">
        <label for="confirm_code">Confirm code</label>
        <input
          id="confirm_code"
          v-model="confirmCode"
          name="confirm_code"
          type="text"
          class="form-control"
          required
        >
        <span v-if="failure" class="help-block">The provided confirm code is invalid.</span>
      </div>

      <div class="text-right">
        <button type="submit" class="btn btn--primary">
          <i v-if="isLoading" class="fas fa-spinner fa-spin fa-fw" />
          Continue
        </button>
      </div>
    </form>
  </blob-panel>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'
import isValid2FACode from '../../functions/isValid2FACode'
import { MessageLevel } from '@qlik-trial/automations-ui'

export default {
  props: {
    google2faSecret: String,
    qrImage: String,
  },

  data() {
    return {
      confirmCode: '',
      failure: false,
      isLoading: false,
    }
  },

  watch: {
    confirmCode(value) {
      if (isValid2FACode(value)) {
        this.submit()
      }
    },
  },

  methods: {
    submit() {
      this.failure = false
      this.isLoading = true

      axios.post(
        '/2fa',
        { confirmCode: this.confirmCode, token: this.token },
        { errorHandling: { 429: false } },
      ).then(() => {
        window.location.href = '/'
      }).catch(error => {
        this.isLoading = false

        if (error.response.status === 429) {
          this.flash({
            message: 'Too many requests have been made. Please try again later.',
            level: MessageLevel.WARNING,
          })
        } else {
          this.failure = true
        }
      })

    },
  },
}
</script>
